import { FC } from 'react';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Tooltip } from '@mui/material';
import { GridFilterItem } from '@mui/x-data-grid-pro';

const getOperatorExplanation = (operator: string) => {
  switch (operator) {
    case 'ilike':
      return '(Case-insensitive pattern match)';
    case 'not,ilike':
      return '(Case-insensitive mismatch)';
    case 'like':
      return '(Case-sensitive pattern match)';
    case 'not,like':
      return '(Case-sensitive mismatch)';
    case 'in':
      return '(Matches any value in list)';
    case 'not,in':
      return '(Doesn`t match any value in list)';
    case 'not':
      return '(Logical negation, used with other operators)';
    case 'is':
      return '(Tests for TRUE, FALSE, or NULL)';
    case 'is,not':
      return '(Tests for not TRUE, not FALSE, or not NULL)';
    case '=':
      return 'Equals (=)';
    case '!=':
      return 'Not Equals (!=)';
    case '>':
      return 'Greater Than (>)';
    case '<':
      return 'Less Than (<)';
    case '>=':
      return 'Greater Than or Equals (>=)';
    case '<=':
      return 'Less Than or Equals (<=)';
    default:
      return '';
  }
};

type OperatorTooltipProps = {
  gridFilterItem: GridFilterItem;
};

const OperatorTooltip: FC<OperatorTooltipProps> = ({ gridFilterItem }) => {
  return (
    <Tooltip
      title={getOperatorExplanation(gridFilterItem.operator)}
      placement='top'
      arrow
    >
      <Box sx={{ position: 'absolute', top: -4, left: -60 }}>
        <HelpOutlineIcon sx={{ width: 15, height: 15 }} />
      </Box>
    </Tooltip>
  );
};

export default OperatorTooltip;
